import { useCallback, useState } from "react";
import {
  invokeWhatsAppCloudTemplateWrite,
  type WhatsAppTemplateWriteRequest,
  type WhatsAppTemplateWriteResult,
} from "@/lib/whatsapp-cloud-templates";

/**
 * Hook admin opcional para BMAPI write de templates Cloud.
 * Sem UI — consumir em páginas internas ou scripts de migração.
 */
export function useWhatsAppCloudTemplateWrite() {
  const [loading, setLoading] = useState(false);
  const [lastResult, setLastResult] = useState<WhatsAppTemplateWriteResult | null>(null);

  const writeTemplate = useCallback(async (request: WhatsAppTemplateWriteRequest) => {
    setLoading(true);
    const result = await invokeWhatsAppCloudTemplateWrite(request);
    setLastResult(result);
    setLoading(false);
    return result;
  }, []);

  return { writeTemplate, loading, lastResult };
}
